import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Divider, Grid, Paper, Typography } from "@mui/material";
import { getReceiptAcknowledgementRetentionDetail } from "../../api/reciptAcknowledgement";
import { useSnack } from "../../services/SnakbarProvider";
import { handleError } from "../../services/errorHandler";

const percentageFormatter = new Intl.NumberFormat("es-MX", {
  style: "percent",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const formatRate = (value) => {
  const numericValue = Number(value);
  if (Number.isNaN(numericValue)) return "N/A";
  return percentageFormatter.format(numericValue / 100);
};

const formatAccount = (account) => {
  if (!account) return "N/A";
  const code = account.contpaqiCode || "N/A"; 
  const name = account.name || "N/A";
  return `${code} | ${name}`;
};

export default function ReceiptAcknowledgementRetentionVisualization({ props }) {
  const { id } = props;
  const { openSnack } = useSnack();
  const [loading, setLoading] = useState(true);
  const [retention, setRetention] = useState(null);

  useEffect(() => {
    const fetchRetentionDetails = async () => {
      if (!id) return;

      try {
        setLoading(true);
        const response = await getReceiptAcknowledgementRetentionDetail(id);
        setRetention(response.data?.taxRetention ?? null);
      } catch (e) {
        openSnack(handleError(e), "error");
      } finally {
        setLoading(false);
      }
    };

    fetchRetentionDetails();
  }, [id, openSnack]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={4}>
        <CircularProgress />
      </Box>
    );
  }

  if (!retention) {
    return (
      <Box p={3}>
        <Typography variant="body1">No hay una regla de retencion activa para este contrarrecibo.</Typography>
      </Box>
    );
  }

  return (
    <Paper elevation={2} sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Regla de retencion activa
      </Typography>
      <Divider sx={{ my: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="body2" color="text.secondary">
            Descripcion
          </Typography>
          <Typography variant="body1">{retention.description || "N/A"}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2" color="text.secondary">
            IVA
          </Typography>
          <Typography variant="body1">
            {formatRate(retention.ivaRate)} | {formatAccount(retention.ivaRetentionAccount)}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2" color="text.secondary">
            ISR
          </Typography>
          <Typography variant="body1">
            {formatRate(retention.isrRate)} | {formatAccount(retention.isrRetentionAccount)}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
}
